export default __webpack_public_path__ + "static/media/Banner1_revamp_Hk.55da542d.webp";